import React, { useState, useEffect } from 'react'
import { Modal, Panel, Table } from 'rsuite'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import { downloadDurableArticlesFile } from '../../../redux/actions/accountingExpenses'
import { isEmpty } from 'lodash-es'
import DownloadButton from '../../../components/buttons/downloadButton/downloadButton'
import { downloadFile } from '../../../utils/fileUtil'
import notification from '../../../utils/notification'
import { doneLoading, startLoading } from '../../../utils/loading'
import { DEFAULT_ERR_MSG } from '../../../constants/msgText'
import { budgetFormat } from '../../../utils/formatterUtil'

export default function ListDepreciationAssetsTable({
  schema,
  loading,
  page = 1,
  displayLength = 5,
  defaultLengthMenu = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
  ],
  onReload = () => {},

  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const [tableData, setTableData] = useState([])
  const fs = localStorage.getItem('fontSize')

  useEffect(() => {
    setTableData(schema.values || [])
  }, [schema.values])

  const handleChangeLength = (dataKey) => {
    onReload(1, dataKey)
  }

  const handleChangePage = (dataKey) => {
    onReload(dataKey, displayLength)
  }

  return (
    <>
      <Table
        wordWrap
        minHeight={350}
        autoHeight
        loading={loading}
        headerHeight={fs <= 15 ? undefined : fs < 16 ? 70 : fs <= 18 ? 75 : 50}
        data={tableData}
        style={{ marginTop: '20px' }}
      >
        <Column width={90} align="center" fixed="left">
          <HeaderCell>ลำดับ</HeaderCell>
          <Cell>
            {(rowData, index) => {
              if (!isEmpty(rowData.assetCode)) {
                return (page - 1) * displayLength + index + 1
              }
            }}
          </Cell>
        </Column>

        <Column width={180} align="left">
          <HeaderCell>รหัสครุภัณฑ์</HeaderCell>
          <Cell dataKey="assetCode" />
        </Column>
        <Column width={250} align="left">
          <HeaderCell>รายการครุภัณฑ์</HeaderCell>
          <Cell dataKey="assetName" />
        </Column>
        <Column width={150} align="left">
          <HeaderCell>วันที่ซื้อหรือได้มา</HeaderCell>
          <Cell dataKey="assetPurchaseDate" />
        </Column>
        <Column width={200} align="right">
          <HeaderCell>ราคาต่อหน่วย(รวม VAT)</HeaderCell>
          <Cell>
            {(rowData) => {
              return budgetFormat(rowData.costPrice)
            }}
          </Cell>
        </Column>
        <Column width={200} align="right">
          <HeaderCell>ค่าเสื่อมราคาสะสม</HeaderCell>
          <Cell>
            {(rowData) => {
              return budgetFormat(rowData.accumulatedDepreciation)
            }}
          </Cell>
        </Column>
        <Column width={200} align="right">
          <HeaderCell>มูลค่าคงเหลือ</HeaderCell>
          <Cell>
            {(rowData) => {
              return budgetFormat(rowData.assetValue)
            }}
          </Cell>
        </Column>
        <Column width={150} align="rileftght">
          <HeaderCell>หน่วย : บาท</HeaderCell>
          <Cell dataKey="assetValueUnit" />
        </Column>

        <Column width={230} align="right">
          <HeaderCell>อายุการใช้งาน (Useful Life)</HeaderCell>
          <Cell dataKey="assetAge" />
        </Column>

        <Column width={160} align="right">
          <HeaderCell>ราคาซาก </HeaderCell>
          <Cell>
            {(rowData) => {
              return budgetFormat(rowData.scrapPrice)
            }}
          </Cell>
        </Column>
      </Table>
      <TablePagination
        lengthMenu={defaultLengthMenu}
        activePage={page}
        renderLengthMenu={(lengthMenu) => {
          return (
            <>
              {lengthMenu}
              {`รายการ/หน้า`}
            </>
          )
        }}
        renderTotal={(total) => {
          return <>{` ทั้งหมด ${total} รายการ`}</>
        }}
        displayLength={displayLength || 5}
        total={schema.totalSize || 0}
        onChangePage={handleChangePage}
        onChangeLength={handleChangeLength}
      />
    </>
  )
}
